/**
 * Custom Pagination Component
 * Extends Ant Design Pagination with custom styling
 */

import { Pagination as AntPagination, PaginationProps } from 'antd';
import classNames from 'classnames';
import './CustomPagination.scss';

export interface CustomPaginationProps extends PaginationProps {
  /** Pagination variant */
  variant?: 'default' | 'simple' | 'minimal';
}

/**
 * CustomPagination Component
 */
export const CustomPagination: React.FC<CustomPaginationProps> = ({
  variant = 'default',
  className,
  ...rest
}) => {
  const paginationClasses = classNames(
    'custom-pagination',
    `custom-pagination--${variant}`,
    className
  );

  return <AntPagination {...rest} className={paginationClasses} />;
};

export default CustomPagination;

